import { render, staticRenderFns } from "./DocumentosPersonales.vue?vue&type=template&id=187b8e00"
import script from "./DocumentosPersonales.vue?vue&type=script&lang=js"
export * from "./DocumentosPersonales.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPersonales.vue?vue&type=style&index=0&id=187b8e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports